var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteFixture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.23576 2.05759C8.40211 1.9808 8.59792 1.9808 8.76427 2.05759L14.6732 4.78486C14.8734 4.87726 14.9999 5.06613 14.9999 5.27273C14.9999 5.47933 14.8734 5.66821 14.6732 5.7606L8.76427 8.48788C8.59792 8.56466 8.40211 8.56466 8.23576 8.48788L2.32678 5.7606C2.1266 5.66821 2.00014 5.47933 2.00014 5.27273C2.00014 5.06613 2.1266 4.87726 2.32678 4.78486L8.23576 2.05759ZM3.91233 5.27273L8.50001 7.39017L13.0877 5.27273L8.50001 3.15529L3.91233 5.27273Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.06251 10.4833C2.20846 10.2139 2.56339 10.1047 2.85528 10.2394L8.5 12.8447L14.1447 10.2394C14.4366 10.1047 14.7915 10.2139 14.9375 10.4833C15.0834 10.7528 14.9651 11.0804 14.6732 11.2151L8.76426 13.9424C8.5979 14.0192 8.4021 14.0192 8.23574 13.9424L2.32677 11.2151C2.03488 11.0804 1.91657 10.7528 2.06251 10.4833Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.85528 7.51212C2.56339 7.3774 2.20846 7.48661 2.06251 7.75606C1.91657 8.0255 2.03488 8.35314 2.32677 8.48786L8.23574 11.2151C8.4021 11.2919 8.5979 11.2919 8.76426 11.2151L14.6732 8.48786C14.9651 8.35314 15.0834 8.0255 14.9375 7.75606C14.7915 7.48661 14.4366 7.3774 14.1447 7.51212L8.5 10.1174L2.85528 7.51212Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteFixture);
export default __webpack_public_path__ + "static/media/whiteFixture.bae342db8866e0d95bcc6e144c2d2078.svg";
export { ForwardRef as ReactComponent };